const BASE_URL = "http://localhost:5000/api";

export async function createAppointment(token, data) {
  const res = await fetch(`${BASE_URL}/appointments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

export async function getAppointments(token) {
  const res = await fetch(`${BASE_URL}/appointments`, {
    headers: { "Authorization": `Bearer ${token}` }
  });
  return res.json();
}
export async function serveAppointment(id, token) {
  const res = await fetch(`http://localhost:5000/api/appointments/${id}/serve`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  return res.json();
}
